import React from 'react';
import '../CSS/footer.css';

const Footer = ()  => {
    return ( 
        <div className="footer-section">
            <footer className='main-footer'>
                <div className="footer-content">
                    <p>Copyright &copy; 2022</p>
                </div>
            </footer>
        </div>
     );
}

export default Footer;